<template>
  <div class="layout-common-menu-card">
    <CardHeader @showMenuDialog="showMenuDialog" @showGroupDialog="showGroupDialog" />
    <div class="tab-box" v-show="visibleTabList.length > 1">
      <el-tabs v-model="activeTab" @tab-click="onTabClick" class="group-tab" ref="elTab" :class="{'group-tab-more': dropDownTabList.length > 0}">
        <el-tab-pane
          v-for="tab in visibleTabList"
          :key="tab.moduleGroupId"
          :name="tab.moduleGroupId"
          :label="tab.moduleGroupName"></el-tab-pane>
      </el-tabs>
      <div class="dropdown-box" v-show="dropDownTabList.length > 0">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" ref="elDropdownMenu">
            <el-dropdown-item
              v-for="hideTab in dropDownTabList"
              :key="hideTab.moduleGroupId"
              :command="hideTab.moduleGroupId">
              {{hideTab.moduleGroupName}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <MenuList :list="mergedLinks" />
    <kye-dialog v-bind="dialogOption"
                :view.sync="dialogOption.view"
                :visible.sync="dialogOption.show">
      <component :is="dialogOption.view"
                :menuGroup="curMenuGroup"
                @update="refresh"
                @close="closeDialog"></component>
    </kye-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { HOME_MENUS } from 'public/config'
import { SVGREG, SVGPATH } from '@/layout/layout/conf'
import dialogMixins from '../dialog'
// 卡片头部
import CardHeader from './card-header.vue'
// 添加常用弹窗
import AddMenuDialog from './add-menu-dialog'
// 分组管理弹窗
import MenuGroupDialog from './menu-group-dialog'
// 模块列表组件
import MenuList from './menu-list/index.vue'

const SVGTICK = (new Date()).toLocaleDateString().replace(/\//g, '')

function getIcon (menu) {
  let icon = menu.icon
  if (icon.startsWith('https')) {
    return icon
  }
  return icon && SVGREG.test(icon)
            ? `${SVGPATH}${icon}?${SVGTICK}`
            : `${SVGPATH}/_MENU/${menu.$ptitle}.svg?${SVGTICK}`
}
export default {
  mixins: [dialogMixins],
  components: { CardHeader, AddMenuDialog, MenuGroupDialog, MenuList },
  data() {
    return {
      links: [],
      tabList: [],
      activeTab: '',
      visibleTabList: [],
      dropDownTabList: [],
      defaultModule: null
    }
  },
  mounted () {
    this.$bus.$once('APP_LOADED', this.init)
    this.$bus.$on('GLOABL_HOME_UPDATE_MENU', this.refresh)
  },
  activated () {
    (!this.links.length) && this.refresh()
  },
  computed: {
    menus () {
      return this.$store.getters.menus
    },
    // 红点数据
    reminds () {
      const remindMenus = this.$store.state.remindMenus
      return Object.keys(remindMenus).filter(key => remindMenus[key])
    },
    filterHomeLinks () {
      return this.formatLinkList(HOME_MENUS)
    },
    mergedLinks () {
      const reminds = [...this.reminds]
      return [...this.filterHomeLinks, ...this.links].map(item => {
        return {
          ...item,
          remindShow: reminds.includes(item.url)
        }
      })
    },
    curMenuGroup () {
      let curMenu = this.tabList.find(item => item.moduleGroupId === this.activeTab)
      if (!curMenu) {
        curMenu = {
          moduleGroupId: this.defaultModule ? this.defaultModule.moduleGroupId : '',
          moduleGroupName: this.defaultModule ? this.defaultModule.moduleGroupName : ''
        }
      }
      return {
        moduleGroupId: curMenu ? curMenu.moduleGroupId : '',
        moduleGroupName: curMenu ? curMenu.moduleGroupName : ''
      }
    }
  },
  methods: {
    showMenuDialog () {
      this.showDialog('AddMenuDialog', '常用模块管理', '830px')
    },
    async init() {
      await this.initMenuList()
      this.onTabClick()
    },
    async refresh (forceUpdate) {
      if (forceUpdate) {
        this.visibleTabList = true
      }
      this.$nextTick(async () => {
        await this.initMenuList()
        this.onTabClick()
      })
    },
    async initMenuList () {
      const res = await this.$http('system.homeModuleGroup.show', {moduleType: '10'})
      this.defaultModule = res.find(item => +item.defaultGroupFlag === 1) // 未分组模块
      this.tabList = res.filter(item => !!item.itemList.length)
      this.activeTab = res[0] ? res[0].moduleGroupId : null
      this.visibleTabList = res.filter(item => !!item.itemList.length)
      this.$nextTick(() => {
        this.updateTabListShow()
      })
    },
    setLinks (arr) {
      this.links = this.formatLinkList(arr)
    },
    // 格式化数据
    formatLinkList (list) {
      const menus = this.menus
      return [...list].filter(item => menus[item.url]).map(item => {
        const menu = menus[item.url]
        return {
          ...item,
          icon: getIcon(menu) || '',
          subSystem: menu.subSystem || '',
          title: menu.title || ''
        }
      })
    },
    showGroupDialog () {
      this.showDialog('MenuGroupDialog', '分组管理', '720px')
    },
    onTabClick () {
      if (!this.activeTab) {
        this.links = []
        return
      }
      const tab = this.tabList.find(item => item.moduleGroupId === this.activeTab)
      const {itemList = []} = tab
      this.links = this.formatLinkList(itemList)
    },
    // 更新tab展示
    updateTabListShow () {
      // el tab 本身有20px的padding
      const paddingWidth = 0
      const tabEle = this.$refs.elTab.$el
      const tabNav = tabEle.querySelector('.el-tabs__nav')
      if (tabNav.offsetWidth + paddingWidth < tabEle.offsetWidth) {
        return
      }
      const tabEleList = tabEle.querySelectorAll('.el-tabs__item')
      let visibleIndex = 0
      let length = paddingWidth
      for (let i = 0; i < tabEleList.length; i++) {
        length += tabEleList[i].offsetWidth
        if (length > tabEle.offsetWidth) {
          break
        } else {
          visibleIndex = i
        }
      }
      this.visibleTabList = cloneDeep(this.tabList.filter((_, index) => index <= visibleIndex))
      this.dropDownTabList = cloneDeep(this.tabList.filter((_, index) => index > visibleIndex))
    },
    handleCommand (command) {
      this.activeTab = command
      this.onTabClick()
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-common-menu-card {
  border-radius: 4px;
  background: #FFFFFF;
  width: 100%;
  overflow-y: auto;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;

  .tab-box {
    width: 100%;
    display: flex;
    height: 29px;
    .group-tab {
      width: 100%;
      &-more {
        width: calc(100% - 60px);
      }
    }
    .dropdown-box {
      display: flex;
      align-items: flex-end;
      width:  60px;
      .el-drowdown {
        width: 100%;
      }
      .el-dropdown-link {
        font-size: 12px;
        color: #333333;
        line-height: 28px;
        display: block;
        height: 28px;
        width: 100%;
        margin-bottom: 1px;
        border-bottom: 1px solid #DCDAE2;
      }
    }
    .el-dropdown {
      width: 100%;
    }
    /deep/ .el-tabs__nav-wrap.is-scrollable {
      padding: 0px;
    }
    /deep/ .el-tabs__nav-prev {
      display: none;
    }
    /deep/ .el-tabs__nav-next {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/index.vue